// import React, { useMemo, useState } from "react";

// const cx = {
//   section: "bg-white shadow rounded-2xl p-5 md:p-6 mb-6 border border-gray-100",
//   h2: "text-xl md:text-2xl font-semibold mb-2",
//   note: "text-sm text-gray-500 mb-4",
//   label: "block text-sm font-medium text-gray-700",
//   input:
//     "mt-1 block w-full rounded-xl border border-black focus:border-black focus:ring-black px-3 py-2",
//   textarea:
//     "mt-1 block w-full rounded-xl border border-black  focus:border-black focus:ring-black px-3 py-2 min-h-[90px]",
//   row: "grid grid-cols-1 md:grid-cols-2 gap-4",
//   btnPrimary:
//     "inline-flex items-center justify-center rounded-xl px-4 py-2 bg-black text-white hover:bg-gray-900 disabled:opacity-50",
//   btnSecondary:
//     "inline-flex items-center justify-center rounded-xl px-4 py-2 bg-gray-100 text-gray-900 hover:bg-gray-200",
//   pill: "inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-800",
//   err: "text-sm text-red-600",
//   ok: "text-sm text-green-600",
// };

// const BASE_URL = "https://api.naseebi.com/v3";
// const IMG_BASE = `${BASE_URL}`;
 
// function Section({ title, description, children }) {
//   const [open, setOpen] = useState(true);

//   return (
//     <section className={cx.section}>
//       <div className="flex items-start justify-between">
//         <div>
//           <h2 className={cx.h2}>{title}</h2>
//           {description ? <p className={cx.note}>{description}</p> : null}
//         </div>
//         <button
//           onClick={() => setOpen((v) => !v)}
//           className={cx.btnSecondary}
//           type="button"
//         >
//           {open ? "Hide" : "Show"}
//         </button>
//       </div>
//       {open ? <div className="mt-4">{children}</div> : null}
//     </section>
//   );
// }

// function useAuthToken() {
//   const [token, setToken] = useState(() => localStorage.getItem("token") || "");
//   const save = (t) => {
//     setToken(t);
//     if (t) localStorage.setItem("token", t);
//     else localStorage.removeItem("token");
//   };
//   return { token, setToken: save };
// }

// async function postJson(url, body, token) {
//   const res = await fetch(url, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       ...(token ? { Authorization: `Bearer ${token}` } : {}),
//     },
//     body: JSON.stringify(body),
//   });
//   const data = await res.json().catch(() => ({}));
//   if (!res.ok)
//     throw new Error(data?.message || `Request failed: ${res.status}`);
//   return data;
// }

// async function postForm(url, formData, token) {
//   const res = await fetch(url, {
//     method: "POST",
//     headers: {
//       ...(token ? { Authorization: `Bearer ${token}` } : {}),
//     },
//     body: formData,
//   });
//   const data = await res.json().catch(() => ({}));
//   if (!res.ok) throw new Error(data?.message || `Upload failed: ${res.status}`);
//   return data;
// }

// export default function App() {
//   const { token, setToken } = useAuthToken();
//  const [registerId, setRegisterId] = useState()
//  console.log("registerId",registerId)
//   // -------- Register form state --------
//   const [reg, setReg] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     password: "",
//     phone: "",
//     gender: "Female",
//   });
//   const [regBusy, setRegBusy] = useState(false);
//   const [regMsg, setRegMsg] = useState({ ok: "", err: "" });

//   // -------- Complete Profile form state --------
//   const [profile, setProfile] = useState({
//     // from your earlier fields list
//     firstName: "",
//     lastName: "",
//     birthDate: "",
//     languages: "", // comma separated
//     dietId: "",
//     religionId: "",
//     maritalStatusId: "",
//     educationId: "",
//     occupationId: "",
//     annualIncomeId: "",
//     heightId: "",
//     employmentTypeId: "",
//     communityId: "",
//     expectation: "",
//     aboutMe: "",
//     prayers: "",
//     smoking: "",
//     alcohol: "",
//     tagline: "",
//     addressLine1: "",
//     addressLine2: "",
//     countryName: "",
//   });
//   const [profBusy, setProfBusy] = useState(false);
//   const [profMsg, setProfMsg] = useState({ ok: "", err: "" });

//   // -------- Image uploads --------
//   const [files, setFiles] = useState({
//     profile: null,
//     cover: null,
//     image1: null,
//     image2: null,
//     image3: null,
//   });
//   const [uploadBusy, setUploadBusy] = useState({
//     profile: false,
//     cover: false,
//     image1: false,
//     image2: false,
//     image3: false,
//   });
//   const [uploadMsg, setUploadMsg] = useState({
//     profile: "",
//     cover: "",
//     image1: "",
//     image2: "",
//     image3: "",
//   });
//   // const [uploadErr, setUploadErr] = useState({
//   //   profile: "",
//   //   cover: "",
//   //   image1: "",
//   //   image2: "",
//   //   image3: "",
//   // });
//   const [faceResult, setFaceResult] = useState(null);

//   const authed = useMemo(() => Boolean(token), [token]);

//   // ----- handlers -----
//   const handleRegChange = (e) => {
//     const { name, value } = e.target;
//     setReg((s) => ({ ...s, [name]: value }));
//   };

//   const handleProfileChange = (e) => {
//     const { name, value } = e.target;
//     setProfile((s) => ({ ...s, [name]: value }));
//   };

//   const handleFile = (key) => (e) => {
//     const file = e.target.files?.[0] || null;
//     setFiles((s) => ({ ...s, [key]: file }));
//   };

//   const registerUser = async (e) => {
//     e.preventDefault();
//     setRegBusy(true);
//     setRegMsg({ ok: "", err: "" });
//     try {
//       // Adjust body according to your customerRegister expectations if different
//       // const data = await postJson(`${BASE_URL}/users/register`, reg, null);
//       const data = await postJson(
//         `${BASE_URL}/users/register`,
//         {
//           ...reg,
//           isAdmin: 1, // ✅ yahan add kar diya
//         },
//         null
//       );
//       setRegisterId(data.user.id)
//       // console.log("user register",data.users.id)
//       // Expecting backend to return a token (common pattern). If your key is different, adjust here.
//       const newToken =
//         data?.token ||
//         data?.data?.token ||
//         data?.authToken ||
//         data?.accessToken ||
//         "";
//       if (newToken) {
//         setToken(newToken);
//         setRegMsg({ ok: "Registered & logged in successfully.", err: "" });
//         setReg({
//           firstName: "",
//           lastName: "",
//           email: "",
//           password: "",
//           phone: "",
//           gender: "Female",
//         });
//       } else {
//         setRegMsg({
//           ok: "",
//           err: "Registered, but no token returned. Please update response mapping in App.jsx.",
//         });
//       }
//     } catch (err) {
//       setRegMsg({ ok: "", err: err.message });
//     } finally {
//       setRegBusy(false);
//     }
//   };

//   const completeProfile = async (e) => {
//     e.preventDefault();
//     setProfBusy(true);
//     setProfMsg({ ok: "", err: "" });
//     try {
//       if (!token)
//         throw new Error("Please register/login first (missing token).");

//       // transform some fields if backend expects arrays/ints
//       const body = {
//         ...profile,
//         id:registerId,
//         isAdmin: 1, // ✅ yahan bhi add kar diya
//         languages: profile.languages
//           ? profile.languages.split(",").map((s) => s.trim())
//           : [],
//       };
//       const data = await postJson(`${BASE_URL}/users/complete`, body, token);
//       setProfMsg({ ok: data?.message || "Profile completed!", err: "" });
//       setProfile({
//         firstName: "",
//         lastName: "",
//         birthDate: "",
//         languages: "", // comma separated
//         dietId: "",
//         religionId: "",
//         maritalStatusId: "",
//         educationId: "",
//         occupationId: "",
//         annualIncomeId: "",
//         heightId: "",
//         employmentTypeId: "",
//         communityId: "",
//         expectation: "",
//         aboutMe: "",
//         prayers: "",
//         smoking: "",
//         alcohol: "",
//         tagline: "",
//         addressLine1: "",
//         addressLine2: "",
//         countryName: "",
//       });
//     } catch (err) {
//       setProfMsg({ ok: "", err: err.message });
//     } finally {
//       setProfBusy(false);
//     }
//   };

//   const uploadImage = (kind) => async (e) => {
//     e.preventDefault();
//     setUploadBusy((s) => ({ ...s, [kind]: true }));
//     setUploadMsg((s) => ({ ...s, [kind]: "" }));
//     // setUploadErr((s) => ({ ...s, [kind]: "" }));
//     setFaceResult(null);

//     try {
//       if (!token)
//         throw new Error("Please register/login first (missing token).");

//       const file = files[kind];
//       if (!file) throw new Error("Please choose an image file first.");

//       const form = new FormData();
//       form.append("image", file);

//       let endpoint = "";
//       if (kind === "profile") endpoint = `${IMG_BASE}/images/uploadProfile`;
//       else if (kind === "cover") endpoint = `${IMG_BASE}/images/uploadCover`;
//       else if (kind === "image1")
//         endpoint = `${IMG_BASE}/images/uploadImageOne`;
//       else if (kind === "image2")
//         endpoint = `${IMG_BASE}/images/uploadImageTwo`;
//       else if (kind === "image3")
//         endpoint = `${IMG_BASE}/images/uploadImageThree`;

//       const data = await postForm(endpoint, form, token);
//       setUploadMsg((s) => ({
//         ...s,
//         [kind]: data?.message || "Uploaded!",
//       }));

//       if (kind === "profile" && data?.faceValidation) {
//         setFaceResult({
//           detected: data.faceValidation.detected,
//           confidence: data.faceValidation.confidence,
//           faceCount: data.faceValidation.faceCount,
//         });
//       }
//     } catch (err) {
//       // setUploadErr((s) => ({ ...s, [kind]: err.message }));
//       console.log(err);
//     } finally {
//       setUploadBusy((s) => ({ ...s, [kind]: false }));
//     }
//   };

//   return (
//     <div className="h-[100vh] bg-gray-50 w-full overflow-y-auto">
//       <header className="max-w-5xl mx-auto px-4 py-6 flex items-center justify-between">
//         <div className="flex items-center gap-3">
//           <div className="h-9 w-9 rounded-2xl bg-black text-white flex items-center justify-center font-bold">
//             N
//           </div>
//           <h1 className="text-2xl font-bold">Naseebi – User Registration</h1>
//         </div>
//         {/* <div className="flex items-center gap-3">
//           {authed ? (
//             <>
//               <span className={cx.pill}>Token stored</span>
//               <button onClick={logout} className={cx.btnSecondary} type="button">
//                 Logout
//               </button>
//             </>
//           ) : (
//             <span className={cx.pill}>Not logged in</span>
//           )}
//         </div> */}
//       </header>

//       <main className="max-w-5xl mx-auto px-4 pb-20">
//         {/* Register */}
//         <Section
//           title="1) Register"
//           // description="Creates the account and stores JWT token for protected routes."
//         >
//           <form onSubmit={registerUser} className="space-y-4">
//             <div className={cx.row}>
//               <div>
//                 <label className={cx.label}>First Name</label>
//                 <input
//                   className={cx.input}
//                   name="firstName"
//                   value={reg.firstName}
//                   onChange={handleRegChange}
//                   required
//                 />
//               </div>
//               <div>
//                 <label className={cx.label}>Last Name</label>
//                 <input
//                   className={cx.input}
//                   name="lastName"
//                   value={reg.lastName}
//                   onChange={handleRegChange}
//                   required
//                 />
//               </div>
//             </div>
//             <div className={cx.row}>
//               <div>
//                 <label className={cx.label}>Email</label>
//                 <input
//                   className={cx.input}
//                   type="email"
//                   name="email"
//                   value={reg.email}
//                   onChange={handleRegChange}
//                   required
//                 />
//               </div>
//               <div>
//                 <label className={cx.label}>Password</label>
//                 <input
//                   className={cx.input}
//                   type="password"
//                   name="password"
//                   value={reg.password}
//                   onChange={handleRegChange}
//                   required
//                 />
//               </div>
//             </div>
//             <div className={cx.row}>
//               <div>
//                 <label className={cx.label}>Phone</label>
//                 <input
//                   className={cx.input}
//                   name="phone"
//                   value={reg.phone}
//                   onChange={handleRegChange}
//                 />
//               </div>
//               <div>
//                 <label className={cx.gender}>Gender</label>
//                 <input
//                   className={cx.input}
//                   type="gender"
//                   name="gender"
//                   value={reg.gender}
//                   onChange={handleRegChange}
//                   required
//                 />
//               </div>
//             </div>

//             <div className="flex items-center gap-3">
//               <button className={cx.btnPrimary} disabled={regBusy}>
//                 {regBusy ? "Registering..." : "Register"}
//               </button>
//               {regMsg.ok ? <p className={cx.ok}>{regMsg.ok}</p> : null}
//               {regMsg.err ? <p className={cx.err}>{regMsg.err}</p> : null}
//             </div>
//           </form>
//         </Section>

//         {/* Complete Profile */}
//         <Section
//           title="2) Complete Profile"
//           // description="Sends all profile fields to POST /complete (protected)."
//         >
//           <form onSubmit={completeProfile} className="space-y-4">
//             <div className={cx.row}>
//               <div>
//                 <label className={cx.label}>First Name</label>
//                 <input
//                   className={cx.input}
//                   name="firstName"
//                   value={profile.firstName}
//                   onChange={handleProfileChange}
//                   required
//                 />
//               </div>
//               <div>
//                 <label className={cx.label}>Last Name</label>
//                 <input
//                   className={cx.input}
//                   name="lastName"
//                   value={profile.lastName}
//                   onChange={handleProfileChange}
//                   required
//                 />
//               </div>
//             </div>

//             <div className={cx.row}>
//               <div>
//                 <label className={cx.label}>Birth Date</label>
//                 <input
//                   className={cx.input}
//                   type="date"
//                   name="birthDate"
//                   value={profile.birthDate}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//               <div>
//                 <label className={cx.label}>Languages (comma separated)</label>
//                 <input
//                   className={cx.input}
//                   name="languages"
//                   placeholder="Urdu, English"
//                   value={profile.languages}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//             </div>

//             <div className={cx.row}>
//               <div>
//                 <label className={cx.label}>Diet ID</label>
//                 <input
//                   className={cx.input}
//                   name="dietId"
//                   value={profile.dietId}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//               <div>
//                 <label className={cx.label}>Religion ID</label>
//                 <input
//                   className={cx.input}
//                   name="religionId"
//                   value={profile.religionId}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//             </div>

//             <div className={cx.row}>
//               <div>
//                 <label className={cx.label}>Marital Status ID</label>
//                 <input
//                   className={cx.input}
//                   name="maritalStatusId"
//                   value={profile.maritalStatusId}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//               <div>
//                 <label className={cx.label}>Education ID</label>
//                 <input
//                   className={cx.input}
//                   name="educationId"
//                   value={profile.educationId}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//             </div>

//             <div className={cx.row}>
//               <div>
//                 <label className={cx.label}>Occupation ID</label>
//                 <input
//                   className={cx.input}
//                   name="occupationId"
//                   value={profile.occupationId}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//               <div>
//                 <label className={cx.label}>Annual Income ID</label>
//                 <input
//                   className={cx.input}
//                   name="annualIncomeId"
//                   value={profile.annualIncomeId}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//             </div>

//             <div className={cx.row}>
//               <div>
//                 <label className={cx.label}>Height ID</label>
//                 <input
//                   className={cx.input}
//                   name="heightId"
//                   value={profile.heightId}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//               <div>
//                 <label className={cx.label}>Employment Type ID</label>
//                 <input
//                   className={cx.input}
//                   name="employmentTypeId"
//                   value={profile.employmentTypeId}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//             </div>

//             <div className={cx.row}>
//               <div>
//                 <label className={cx.label}>Community ID</label>
//                 <input
//                   className={cx.input}
//                   name="communityId"
//                   value={profile.communityId}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//               <div>
//                 <label className={cx.label}>Prayers</label>
//                 <input
//                   className={cx.input}
//                   name="prayers"
//                   value={profile.prayers}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//             </div>

//             <div className={cx.row}>
//               <div>
//                 <label className={cx.label}>Smoking</label>
//                 <input
//                   className={cx.input}
//                   name="smoking"
//                   value={profile.smoking}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//               <div>
//                 <label className={cx.label}>Alcohol</label>
//                 <input
//                   className={cx.input}
//                   name="alcohol"
//                   value={profile.alcohol}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//             </div>

//             <div className={cx.row}>
//               <div>
//                 <label className={cx.label}>Tagline</label>
//                 <input
//                   className={cx.input}
//                   name="tagline"
//                   value={profile.tagline}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//               <div>
//                 <label className={cx.label}>Country</label>
//                 <input
//                   className={cx.input}
//                   name="countryName"
//                   value={profile.countryName}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//             </div>

//             <div className={cx.row}>
//               <div>
//                 <label className={cx.label}>Address Line 1</label>
//                 <input
//                   className={cx.input}
//                   name="addressLine1"
//                   value={profile.addressLine1}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//               <div>
//                 <label className={cx.label}>Address Line 2</label>
//                 <input
//                   className={cx.input}
//                   name="addressLine2"
//                   value={profile.addressLine2}
//                   onChange={handleProfileChange}
//                 />
//               </div>
//             </div>

//             <div>
//               <label className={cx.label}>Expectation</label>
//               <textarea
//                 className={cx.textarea}
//                 name="expectation"
//                 value={profile.expectation}
//                 onChange={handleProfileChange}
//               />
//             </div>

//             <div>
//               <label className={cx.label}>About Me</label>
//               <textarea
//                 className={cx.textarea}
//                 name="aboutMe"
//                 value={profile.aboutMe}
//                 onChange={handleProfileChange}
//               />
//             </div>

//             <div className="flex items-center gap-3">
//               <button className={cx.btnPrimary} disabled={profBusy}>
//                 {profBusy ? "Saving..." : "Save Profile"}
//               </button>
//               {profMsg.ok ? <p className={cx.ok}>{profMsg.ok}</p> : null}
//               {profMsg.err ? <p className={cx.err}>{profMsg.err}</p> : null}
//             </div>
//           </form>
//         </Section>

//         {/* Image Uploads */}
//         <Section
//           title="3) Upload Profile Image (with Face Validation)"
//           // description='POST /image/uploadProfile — field name "image"; shows face detection result if your backend returns it.'
//         >
//           <form onSubmit={uploadImage("profile")} className="space-y-4">
//             <div>
//               <label className={cx.label}>Choose Image</label>
//               <input
//                 className={cx.input}
//                 type="file"
//                 accept="image/*"
//                 onChange={handleFile("profile")}
//               />
//             </div>
//             <div className="flex items-center gap-3">
//               <button className={cx.btnPrimary} disabled={uploadBusy.profile}>
//                 {uploadBusy.profile ? "Uploading..." : "Upload Profile Image"}
//               </button>
//               {uploadMsg.profile ? (
//                 <p className={cx.ok}>{uploadMsg.profile}</p>
//               ) : null}
//               {/* {uploadErr.profile ? (
//                 <p className={cx.err}>{uploadErr.profile}</p>
//               ) : null} */}
//             </div>

//             {faceResult ? (
//               <div className="mt-3 rounded-xl bg-gray-50 p-3 border">
//                 <div className="font-medium mb-1">Face Validation</div>
//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-sm">
//                   <div>
//                     Detected:{" "}
//                     <span className="font-semibold">
//                       {String(faceResult.detected)}
//                     </span>
//                   </div>
//                   <div>
//                     Confidence:{" "}
//                     <span className="font-semibold">
//                       {faceResult.confidence ?? "—"}
//                     </span>
//                   </div>
//                   <div>
//                     Face Count:{" "}
//                     <span className="font-semibold">
//                       {faceResult.faceCount ?? "—"}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             ) : null}
//           </form>
//         </Section>

//         <Section title="4) Upload Cover">
//           <form onSubmit={uploadImage("cover")} className="space-y-4">
//             <div>
//               <label className={cx.label}>Choose Image</label>
//               <input
//                 className={cx.input}
//                 type="file"
//                 accept="image/*"
//                 onChange={handleFile("cover")}
//               />
//             </div>
//             <div className="flex items-center gap-3">
//               <button className={cx.btnPrimary} disabled={uploadBusy.cover}>
//                 {uploadBusy.cover ? "Uploading..." : "Upload Cover"}
//               </button>
//               {uploadMsg.cover ? (
//                 <p className={cx.ok}>{uploadMsg.cover}</p>
//               ) : null}
//               {/* {uploadErr.cover ? <p className={cx.err}>{uploadErr.cover}</p> : null} */}
//             </div>
//           </form>
//         </Section>

//         <Section
//           title="5) Upload Gallery Images"
//           // description='POST /image/uploadImageOne|Two|Three — field "image".'
//         >
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//             {/* Image 1 */}
//             <form
//               onSubmit={uploadImage("image1")}
//               className="space-y-3 border rounded-xl p-4"
//             >
//               <div className="font-medium">Image 1</div>
//               <input
//                 className={cx.input}
//                 type="file"
//                 accept="image/*"
//                 onChange={handleFile("image1")}
//               />
//               <button className={cx.btnPrimary} disabled={uploadBusy.image1}>
//                 {uploadBusy.image1 ? "Uploading..." : "Upload Image 1"}
//               </button>
//               {uploadMsg.image1 ? (
//                 <p className={cx.ok}>{uploadMsg.image1}</p>
//               ) : null}
//               {/* {uploadErr.image1 ? (
//                 <p className={cx.err}>{uploadErr.image1}</p>
//               ) : null} */}
//             </form>

//             {/* Image 2 */}
//             <form
//               onSubmit={uploadImage("image2")}
//               className="space-y-3 border rounded-xl p-4"
//             >
//               <div className="font-medium">Image 2</div>
//               <input
//                 className={cx.input}
//                 type="file"
//                 accept="image/*"
//                 onChange={handleFile("image2")}
//               />
//               <button className={cx.btnPrimary} disabled={uploadBusy.image2}>
//                 {uploadBusy.image2 ? "Uploading..." : "Upload Image 2"}
//               </button>
//               {uploadMsg.image2 ? (
//                 <p className={cx.ok}>{uploadMsg.image2}</p>
//               ) : null}
//               {/* {uploadErr.image2 ? (
//                 <p className={cx.err}>{uploadErr.image2}</p>
//               ) : null} */}
//             </form>

//             {/* Image 3 */}
//             <form
//               onSubmit={uploadImage("image3")}
//               className="space-y-3 border rounded-xl p-4"
//             >
//               <div className="font-medium">Image 3</div>
//               <input
//                 className={cx.input}
//                 type="file"
//                 accept="image/*"
//                 onChange={handleFile("image3")}
//               />
//               <button className={cx.btnPrimary} disabled={uploadBusy.image3}>
//                 {uploadBusy.image3 ? "Uploading..." : "Upload Image 3"}
//               </button>
//               {uploadMsg.image3 ? (
//                 <p className={cx.ok}>{uploadMsg.image3}</p>
//               ) : null}
//               {/* {uploadErr.image3 ? (
//                 <p className={cx.err}>{uploadErr.image3}</p>
//               ) : null} */}
//             </form>
//           </div>
//         </Section>
//       </main>

//       <footer className="text-center text-xs text-gray-500 py-8">
//         Built with React + Tailwind, wired to your v2 APIs.
//       </footer>
//     </div>
//   );
// }
"use client";

import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";

export default function MultiStepProfileForm() {
  const [step, setStep] = useState(1);
  const [token, setToken] = useState(null);

  // Dropdown states
  const [personalOptions, setPersonalOptions] = useState({});
  const [marriageOptions, setMarriageOptions] = useState({});
  const [beliefOptions, setBeliefOptions] = useState({});
  const [educationOptions, setEducationOptions] = useState({});
  const [hobbyOptions, setHobbyOptions] = useState({});

  // Form data state
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    religion: "",
    maritalStatus: "",
    diet: "",
    education: "",
    hobbies: [],
    aboutMe: "",
    profileImage: null,
    coverImage: null,
    gallery: []
  });

  useEffect(() => {
    const auth = localStorage.getItem("authToken");
    if (auth) setToken(auth);

    const fetchData = async () => {
      try {
        // Personal Details
        const personalRes = await axios.get(`https://api.naseebi.com/v3/profile/personalDetails`);
        console.log("Personal Data:", personalRes.data);
        setPersonalOptions(personalRes.data);

        // Marriage Plans
        const marriageRes = await axios.get(`https://api.naseebi.com/v3/profile/marriagePlans`);
        console.log("Marriage Data:", marriageRes.data);
        setMarriageOptions(marriageRes.data);

        // Beliefs & Lifestyle
        const beliefRes = await axios.get(`https://api.naseebi.com/v3/profile/beliefsAndLifeStyle`);
        console.log("Beliefs Data:", beliefRes.data);
        setBeliefOptions(beliefRes.data);

        // Education & Careers
        const eduRes = await axios.get(`https://api.naseebi.com/v3/profile/educationsAndCareers`);
        console.log("Education Data:", eduRes.data);
        setEducationOptions(eduRes.data);

        // Hobbies
        const hobbyRes = await axios.get(`https://api.naseebi.com/v3/profile/hobbies`);
        console.log("Hobbies Data:", hobbyRes.data);
        setHobbyOptions(hobbyRes.data);

      } catch (err) {
        console.error("Error fetching dropdowns", err);
      }
    };

    fetchData();
  }, []);

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      if (name === "gallery") {
        setFormData({ ...formData, gallery: Array.from(files) });
      } else {
        setFormData({ ...formData, [name]: files[0] });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // Submit Step Data
  const handleSubmit = async () => {
    try {
      if (!token) {
        toast.error("No auth token found");
        return;
      }

      let endpoint = "";
      let payload = {};

      if (step === 1) {
        endpoint = "/personalDetails";
        payload = {
          name: formData.name,
          email: formData.email,
          password: formData.password,
        };
      } else if (step === 2) {
        endpoint = "/educationAndCareer";
        payload = {
          religion: formData.religion,
          maritalStatus: formData.maritalStatus,
          diet: formData.diet,
          education: formData.education,
          hobbies: formData.hobbies,
          aboutMe: formData.aboutMe,
        };
      } else if (step === 3) {
        endpoint = "/personalDetails";
        const formDataUpload = new FormData();
        if (formData.profileImage)
          formDataUpload.append("profileImage", formData.profileImage);
        if (formData.coverImage)
          formDataUpload.append("coverImage", formData.coverImage);
        formData.gallery.forEach((file, idx) => {
          formDataUpload.append(`gallery[${idx}]`, file);
        });

        await axios.put(`/profile${endpoint}`, formDataUpload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });

        toast.success("Profile images uploaded successfully!");
        return;
      }

      if (endpoint) {
        await axios.put(`/profile${endpoint}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success(`Step ${step} data saved!`);
      }

      setStep(step + 1);
    } catch (err) {
      console.error("Error submitting form", err);
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="max-w-xl mx-auto p-6 bg-white rounded-xl shadow-md">
      <h2 className="text-xl font-bold mb-4">Step {step} of 3</h2>

      {/* Step 1 */}
      {step === 1 && (
        <div className="space-y-4">
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            className="border p-2 w-full"
            value={formData.name}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            className="border p-2 w-full"
            value={formData.email}
            onChange={handleChange}
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            className="border p-2 w-full"
            value={formData.password}
            onChange={handleChange}
          />
        </div>
      )}

      {/* Step 2 */}
      {step === 2 && (
        <div className="space-y-4">
          <select
            name="religion"
            value={formData.religion}
            onChange={handleChange}
            className="border p-2 w-full"
          >
            <option value="">Select Religion</option>
            {beliefOptions.religions?.map((r) => (
              <option key={r.id} value={r.value}>
                {r.label}
              </option>
            ))}
          </select>

          <select
            name="maritalStatus"
            value={formData.maritalStatus}
            onChange={handleChange}
            className="border p-2 w-full"
          >
            <option value="">Select Marital Status</option>
            {personalOptions.maritalStatuses?.map((m) => (
              <option key={m.id} value={m.value}>
                {m.label}
              </option>
            ))}
          </select>

          <select
            name="diet"
            value={formData.diet}
            onChange={handleChange}
            className="border p-2 w-full"
          >
            <option value="">Select Diet</option>
            {beliefOptions.diets?.map((d) => (
              <option key={d.id} value={d.value}>
                {d.label}
              </option>
            ))}
          </select>

          <select
            name="education"
            value={formData.education}
            onChange={handleChange}
            className="border p-2 w-full"
          >
            <option value="">Select Education</option>
            {educationOptions.educations?.map((e) => (
              <option key={e.id} value={e.value}>
                {e.label}
              </option>
            ))}
          </select>

          <select
            name="hobbies"
            value={formData.hobbies}
            onChange={handleChange}
            multiple
            className="border p-2 w-full"
          >
            {hobbyOptions?.map((h) => (
              <option key={h.id} value={h.value}>
                {h.label}
              </option>
            ))}
          </select>

          <textarea
            name="aboutMe"
            placeholder="Write about yourself"
            className="border p-2 w-full"
            value={formData.aboutMe}
            onChange={handleChange}
          />
        </div>
      )}

      {/* Step 3 */}
      {step === 3 && (
        <div className="space-y-4">
          <label>Profile Image</label>
          <input type="file" name="profileImage" onChange={handleChange} />

          <label>Cover Image</label>
          <input type="file" name="coverImage" onChange={handleChange} />

          <label>Gallery Images</label>
          <input type="file" name="gallery" multiple onChange={handleChange} />
        </div>
      )}

      <button
        onClick={handleSubmit}
        className="mt-6 px-4 py-2 bg-blue-600 text-white rounded-lg"
      >
        {step === 3 ? "Finish" : "Next"}
      </button>
    </div>
  );
}
